var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maindiv snotice-wrap"},[_c('div',{staticClass:"ht200 sindex-bg"}),_vm._v(" "),_c('div',{staticClass:"bar-menu2 wd1200 tcenter fs0 pb40 pt30"},[_c('left'),_vm._v(" "),_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e871b4be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/enroll/goArticle.vue
// module id = null
// module chunks = 